import { Box, Image } from '@domain-group/suit-theme'

import useProvider from '@hooks/useProvider'

import type { ProviderModel } from '@models/types'

import placeholderImageUrl from './assets/placeholder.svg'

interface ProviderLogoProps {
  boxProps?: object,
  height?: number,
  provider: ProviderModel,
  width?: number,
}

const ProviderLogo = (props: ProviderLogoProps) => {
  const {
    boxProps,
    height = 50,
    provider,
    width = 84,
  } = props

  const providerPayload = useProvider(provider)
  const { alternateLogoUrl } = providerPayload

  return (
    <Box
      borderRadius={5}
      border="1px solid"
      borderColor="lineColor"
      height={height}
      overflow="hidden"
      width={width}
      {...boxProps}
    >
      <Image
        backgroundSize="contain"
        // @ts-expect-error TS2322
        border="1px solid"
        borderColor="lineColor"
        borderRadius={5}
        placeholderUrl={placeholderImageUrl}
        url={alternateLogoUrl}
        height={height - 1}
        width={width - 1}
      />
    </Box>
  )
}

export default ProviderLogo
